<template>
  <v-card>
    <v-card-text class="pa-0">
      <cropper
        :src="img"
        :stencil-component="$options.components.CircleStencil"
        ref="cropper"
      />
    </v-card-text>
    <v-card-actions>
      <v-btn small @click="$emit('cancel', false)">Cancel</v-btn>
      <v-spacer />
      <v-btn small color="primary" @click="crop">Update</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { CircleStencil, Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

export default {
  components: {
    Cropper,
    // eslint-disable-next-line vue/no-unused-components
    CircleStencil
  },
  props: {
    img: {
      type: String,
      required: true
    }
  },
  methods: {
    crop () {
      const { canvas } = this.$refs.cropper.getResult()
      this.$emit('crop', canvas.toDataURL())
      this.$emit('cancel', false)
    }
  }
}
</script>
